<template>
  <div class="ranking-page-panel">
    <q-card class="my-card">
      <q-card-section class="card-section">
        <div class="card-title">Ranking (Top 25)</div>
      </q-card-section>
      <q-separator />

      <q-card-section class="card-content">
        <q-tabs v-model="tab" class="tab-section">
          <q-tab 
            v-for="tab in tabs"
            :key="tab"
            :name="tab"
            :label="tab"
            @click="tabChange(tab)"
          />
        </q-tabs>
      </q-card-section>

      <q-card-section class="card-content-slot">
        <div v-for="(data, indexColum) in rankingColumn" :key="data.ChaName">
          <ranking-slot
            v-for="(ranking, index) in data"
            :key="ranking.idx"
            :chaInfo="ranking"
            :type="tab"
            :rankNum="indexColum == 0 ? index + 1 : index + rankingColumn[indexColum - 1].length + 1"
          />
        </div>
        
      </q-card-section>
    </q-card>
  </div>
</template>
<script>
import RankingSlot from '@/components/ranking/RankingSlot.vue';
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'RankingPage',
  data () {
    return {
      tab: 'Top Kill',
      tabs: [
        'Top Kill',
        'Richest',
        'Brawler',
        'Swordsman',
        'Shaman(Resu)',
        'Shaman(Kills)',
        'Archer',
        'SG',
        'MP',
        'PHNX'
      ],
      column: 2
    }
  },
  components: {
    RankingSlot
  },
  computed: {
    ...mapGetters({
      getRanking: 'ranking/getRanking'
    }),
    rankingColumn () {
      let column = []

      if (this.getRanking) {
        let ranking = this.getRanking

        if (!ranking) return []

        const mid = Math.ceil(ranking.length / this.column)

        for (let col = 0; col < this.column; col++) {
          column.push(ranking.slice(col * mid, col * mid + mid))
        }
      }

      return column
    }
  },
  async mounted () {
   this.tabChange('Top Kill')
  },
  methods: {
    ...mapActions({
      requestRanking: 'ranking/requestRanking'
    }),
    async tabChange (tab) {
      const parameters = {
        type: tab
      }
      
      this.$q.loading.show();
      
      await this.recaptchaLoad('getranking')
  
      await this.requestRanking(parameters)

      this.$q.loading.hide()
    }
  }
}
</script>
<style lang="scss">
.ranking-page-panel {
  .my-card {
    background-color: $backgroundHeader;
    
    .card-title {
      font-size: 16px;
      font-weight: 700;
    }

    .card-section {
      color: white;
    }

    .card-content {
      background-color: $background;
      color: white;
    }

    .tab-section {
      color: white;
    }
    .card-content-slot {
      background-color: $background;
      display: flex;
      gap: 16px;
      margin-left: auto;
      padding-left: 18%;

      .class-type {
        img {
          width: 50px;
          height: 50px;
        }
      }
    }
  }
}
</style>